module.exports = __webpack_public_path__ + "img/searchFailedInfluencer.d8d7d101.svg";